import styled from "styled-components";

const CardStyled = styled.div`
    border-radius: 6px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
`;

export const FormPageWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 44px;
`;

export const FormContainer = styled(CardStyled)`
    width: 556px;
    max-width: 100%;
    padding: 48px 70px;
    margin-top: 40px;
    form {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        gap: 24px;
        button {
            margin-top: 16px;
        }
    }
    .catalogue__buttons-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        gap: 24px;
    }
    @media (max-width: 420px) {
        padding: 20px 24px;
    }
`;

export const Input = styled.input`
    border-radius: 5px;
    border: ${({ errorStyle }) =>
        errorStyle ? "1px solid var(--negativeColor)" : "1px solid #f4f4f4"};
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1) !important;
    height: 46px;
    width: 100%;
    margin-top: 10px;
    padding-left: 12px;
    color: #000;
    background: #fff;
    opacity: ${({ disabled }) => disabled && "0.5"};
    :focus {
        outline: none;
    }
    ::placeholder {
        color: #979797;
        font-size: 1rem;
        font-weight: 600;
        line-height: 16px;
    }
`;

export const TextArea = styled.textarea`
    border-radius: 5px;
    border: ${({ errorStyle }) =>
        errorStyle ? "1px solid var(--negativeColor)" : "1px solid #f4f4f4"};
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1) !important;
    height: 78px;
    width: 100%;
    margin-top: 10px;
    padding: 16px 12px;
    color: #000;
    background: #fff;
    opacity: ${({ disabled }) => disabled && "0.5"};
    resize: none;
    :focus {
        outline: none;
    }
    ::placeholder {
        color: #979797;
        font-size: 1rem;
        font-weight: 600;
        line-height: 16px;
    }
`;

export const Label = styled.label`
    color: #000;
    width: 100%;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    opacity: ${({ disabled }) => disabled && "0.5"};
`;

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;

    .payroll-setup__label-wrap {
        display: flex;
    }
    .payroll-add-employee__paste-wrap {
        position: absolute;
        height: 20px;
    }
    .payroll-add-employee__name-enq-wrap {
        width: 100%;
        position: absolute;
        bottom: -25px;
        right: 0px;
        .beneficiary-wrap {
            font-size: 0.8125rem;
        }
        .verifiedIcon {
            margin-right: 4px;
        }
    }
`;
export const NumberInputStyled = styled.div`
    border-radius: 5px;
    border: 1px solid var(--dark-mode-text, #f4f4f4);
    background: #fff;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    height: 46px;
    padding-right: 0px;
    align-items: center;
    width: 100%;
    font-size: 1rem;
    font-weight: 600;
    line-height: 16px;
    color: #000;
    margin-top: 10px;
    opacity: ${({ disabled }) => disabled && "0.5"};

    .account__number-input-box {
        display: flex;
        width: 42px;
        height: 100%;
        padding: 15px 7px;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        border: 1px solid #121212;
        background: #f4f4f4;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
    }
    .account__number-input {
        border: 0px;
        height: 100%;
        width: calc(100% - 42px);
        padding-left: 12px;
        :focus {
            outline: none;
        }
        ::placeholder {
            color: #979797;
        }
        :disabled {
            background: #fff;
        }
    }
`;

export const NormalText = styled.p`
    font-size: 0.9375rem;
    font-weight: 400;
    line-height: 20px;
    color: ${({ customColor }) => (customColor ? customColor : "#000000")};
`;

export const SmallText = styled(NormalText)`
    color: #979797;
    font-size: 0.813rem;
    line-height: normal;
`;

export const ModalWrapper = styled.div`
    border-radius: 6px;
    border: 1px solid rgba(219, 220, 224, 0.5);
    background: #fff;
    box-shadow: 15px 30px 40px 0px rgba(0, 0, 0, 0.07);
    max-width: 100%;

    h3 {
        font-size: 1.25rem;
        font-weight: 900;
        line-height: 25px;
        color: #000;
        text-align: center;
    }
    .catalogue-modal__buttons-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        gap: 20px;
    }
`;

export const SuccessMessageStyled = styled(NormalText)`
    text-align: center;
    font-size: 1rem;
`;
